/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SECTION_OPTION = gql`
  query GetFullCostumeFeatureInventories(
    $filters: FeatureInvInput
    $options: GetManyOptions
  ) {
    getFullCostumeFeatureInventories(filters: $filters, options: $options) {
      currentPage
      limit
      skip
      totalPages
      count
      content {
        CV {
          inventory
          name
          id
        }
        CA {
          name
          id
        }
        costumeType {
          name
        }
        section {
          name
        }
        presentation {
          name
        }
        id
        name
        registered
        remaining
        CVInventory
        History {
          date
          name
          email
          description
        }
      }
    }
  }
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
